var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home",class:_vm.$store.state.daynight ? 'container1' : 'container'},[_c('BaseHeader'),_c('h4',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('CRFIInvestment')))]),_c('div',{staticClass:"content bg"},_vm._l((_vm.CRFIList),function(item,index){return _c('BaseItem',{key:index,attrs:{"info":item,"index":index}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }